<app-consumption-report-search-criteria
    (searchCriteria)="updateConsumptionCriteria($event)"
    [hidden]="criteria !== null" />
<app-consumption-result-table
    [criteria]="criteria"
    [hidden]="criteria === null"
    (backToCriteria)="backToCriteria()" />
